import { Injectable } from "@angular/core";

@Injectable({
	providedIn: "root",
})
export class OperatingSystemHelperService {
	constructor() {}

	static getOsInformations() {
		const osInformation = {
			osName: "unknow",
			majorVersion: "0",
			minorVersion: "0",
			releaseVersion: "0",
		};

		if (navigator.platform.includes("Mac")) {
			osInformation.osName = "Macintosh";
			// "5.0 (Macintosh; Intel Mac OS X 10_14_5) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/12.1.1 Safari/605.1.15"
			const versionOs = navigator.userAgent.substring(
				navigator.userAgent.indexOf("Mac OS X ") + 9,
				navigator.userAgent.indexOf(") "),
			);
			const versionMac = versionOs.split("_");

			osInformation.majorVersion = versionMac[0];
			osInformation.minorVersion = versionMac[1];
			osInformation.releaseVersion = versionMac[2];
		} else if (navigator.platform.includes("Win") || navigator.platform.includes("Linux")) {
			osInformation.osName = "Window";
			// "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/74.0.3729.169 Safari/537.36"
			let versionOs = navigator.userAgent.substring(
				navigator.userAgent.indexOf(" NT ") + 4,
				navigator.userAgent.indexOf("; "),
			);

			const versionWinTmp = "";
			try {
				const versionWinTmp = parseFloat(versionOs);
				if (isNaN(versionWinTmp)) {
					versionOs = "5.0";
				}
			} catch (e) {
				versionOs = "5.0";
			}
			const versionWin = versionOs.split(".");

			osInformation.majorVersion = versionWin[0];
			osInformation.minorVersion = versionWin[1];
		}

		return osInformation;
	}

	static comparePathContext(path, context) {
		const contextArray = context.toLowerCase().split("/");
		const pathArray = path.toLowerCase().split("/");
		let isMatched = true;

		for (let i = 0; i < contextArray.length && isMatched; i++) {
			if (!pathArray.includes(contextArray[i])) {
				isMatched = false;
			}
		}

		return isMatched;
	}
}
